import { ValidatorTypes } from "../../../../util/validators";
export const levelFields = {
    name: {
        name: 'name',
        label: 'Name',
        type: 'text',
        touched: false,
        error: false,
        valid: true,
        value: '',
        validation: [ValidatorTypes.REQUIRED]
    },
    description: {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        touched: false,
        error: false,
        valid: true,
        value: '',
        validation: [ValidatorTypes.REQUIRED, ValidatorTypes.TEXTAREA]
    },
    calloutCost: {
        name: 'calloutCost',
        label: 'Call Out Charge Amount',
        type: 'amount',
        touched: false,
        error: false,
        valid: true,
        value: '',
        validation: [ValidatorTypes.NUMBER]
    },
    calloutAverageCost: {
        name: 'calloutAverageCost',
        label: 'Average Cost',
        type: 'amount',
        touched: false,
        error: false,
        valid: true,
        value: '',
        validation: [ValidatorTypes.NUMBER]
    },
    travelCost: {
        name: 'travelCost',
        label: 'Travel Charge Amount',
        type: 'amount',
        touched: false,
        error: false,
        valid: true,
        value: '',
        validation: [ValidatorTypes.NUMBER]
    },
    travelAverageCost: {
        name: 'travelAverageCost',
        label: 'Average Cost',
        type: 'amount',
        touched: false,
        error: false,
        valid: true,
        value: '',
        validation: [ValidatorTypes.NUMBER]
    }
}